import Vue from 'vue'
import { Message } from 'element-ui';
import App from './App.vue'
import router from './router'
import store from './store'
// import axios from 'axios'
import http from './http'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

Vue.config.productionTip = false
Vue.prototype.$message = Message;
Vue.prototype.$http = http

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
